const locationsLevelsActionTypes = {
  SET_LOCATIONS_LEVELS: 'SET_LOCATIONS_LEVELS',
};
export default locationsLevelsActionTypes;
